@if (hasWebsite) {
  <a [href]="website" target="_blank" class="endorsement-link">
    <div class="endorsement-item-container">
      <div class="endorsement-image" [responsiveBackgroundImage]="image">
        <div class="endorsement-gradient"></div>
      </div>
      <div class="endorsement-label">
        <div class="endorsement-name">{{ endorsement.name }}</div>
        <div class="endorsement-title">{{ endorsement.title }}</div>
        <div class="endorsement-bio">{{ endorsement.bio }}</div>
      </div>
    </div>
  </a>
} @else {
  <div class="endorsement-item-container">
    <div class="endorsement-image" [responsiveBackgroundImage]="image">
      <div class="endorsement-gradient"></div>
    </div>
    <div class="endorsement-label">
      <div class="endorsement-name">{{ endorsement.name }}</div>
      <div class="endorsement-title">{{ endorsement.title }}</div>
      <div class="endorsement-bio">{{ endorsement.bio }}</div>
    </div>
  </div>
}
